import FormSection from 'components/FormSection';
import GlowingBorder from '../BaseComponents/GlowingBorder';
import { BusinessOutline } from 'react-ionicons';
import { CartSiteAddress } from '../CartProvider';

const ServiceAddressFormSection = ({
  location,
}: {
  location: CartSiteAddress;
}) => {
  return (
    <FormSection title="Service address" gridClassName="relative grid-cols-1">
      <GlowingBorder />
      <div className="service-address-checkout flex justify-between rounded p-4">
        <p className="flex gap-2">
          <BusinessOutline width="21px" height="21px" color="#F8FAFC" />
          <span className="font-bold text-content-base-default">
            {location?.address_line_1}, {location?.city}, {location?.state}{' '}
            {location?.zip}
          </span>
        </p>
        <p className="font-bold text-content-base-subdued">
          {location?.macnum
            ? `Account # ${location.macnum}`
            : 'No account found'}
        </p>
      </div>
    </FormSection>
  );
};

export default ServiceAddressFormSection;
